export default {
  name: 'Responses',
  props: {
    readOnly: { type: Boolean, default: false },
    responses: { type: Object, required: true },
    onChanged: { type: Function, default: () => {} }
  }
}
